var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32815 1.56262C1.07852 1.56262 1.07852 3.43707 2.32815 3.43707H17.6781C18.9289 3.43707 18.9289 1.56262 17.6781 1.56262H2.32815ZM17.704 9.06277H2.32697C1.02773 9.01198 1.02773 11.0116 2.32697 10.9372H17.6769C18.9525 10.9868 18.9773 9.06277 17.7029 9.06277H17.704ZM2.32697 16.5629C1.07734 16.5629 1.07734 18.4374 2.32697 18.4374H17.6769C18.9277 18.4374 18.9277 16.5629 17.6769 16.5629H2.32697Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.b7bd63ef5edecf648005d9989ad10f49.svg";
export { ForwardRef as ReactComponent };